function ConnectionToast() {
    return (
        <div className="toasts">
            <div id="connectionLost" className="toast" role="alert" aria-live="assertive" aria-atomic="true">
                <div className="toast-header">
                    <strong className="me-auto">Connection lost ...</strong>
                    <small>Now</small>
                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div className="toast-body">
                    Your internet connection lost!
                </div>
            </div>
        </div>
    )
}

export default ConnectionToast;